module.exports = __webpack_public_path__ + "img/00052.b781fb4c.webp";